<template>
  <section class="section">
    <div class="tabName">{{$route.meta.title}}</div>
    <div class="app-main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews">
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
.section{
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.app-main {
  /* 50= navbar  50  */
  height: calc(100% - 36px);
  width: 100%;
  position: relative;
  padding: 20px 25px;
  box-sizing: border-box;
  overflow: hidden;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
.tabName{
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  font-weight: 500;
  background: #EFF2F5;
  height:36px;
  line-height: 36px;
  padding-left:24px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
